module.exports = __webpack_public_path__ + "static/media/reason-money-icon.13de5700.svg";